import { z } from "zod";

export const numberedStepsListPropsSchema = z.object({
  heading: z.string(),
  steps: z.array(
    z.object({
      title: z.string(),
      description: z.string(),
      annotation: z.string().optional().nullable(),
    }),
  ),
});
